import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { __API_URL__ } from "../../SERVER_URL";

const ClinicAdmin = (props) => {
  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const role = user_data.role;
  const [allFieldsFilled, setAllFieldsFilled] = useState(false);

  const handleFieldChange = (e, fieldName) => {
    props.setClinicData({
      ...props.clinicData,
      [fieldName]: e.target.value,
    });
    const requiredFields = ["email", "confirm_email", "first_name", "last_name", "phone"];
    const isAllFilled = requiredFields.every((field) => props.clinicData[field]);
    setAllFieldsFilled(isAllFilled);
  };

  const handlePaste = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (role === "Super Admin" || role === "Clinic Admin") {
      props.GetClinics();
    }
  }, []);

  return (
    <Dialog
      open
      onClose={() => props.clinicModalShow(false)}
      maxWidth="sm"
      fullWidth
      aria-labelledby="clinic-admin-dialog-title"
    >
      <DialogTitle id="clinic-admin-dialog-title">
        Add Clinic Subject
        <IconButton
          aria-label="close"
          onClick={() => props.clinicModalShow(false)}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Email"
          type="email"
          fullWidth
          margin="normal"
          size="small"
          name="email"
          value={props.clinicData?.email}
          onChange={(e) => handleFieldChange(e, "email")}
          onPaste={handlePaste}
        />
        <TextField
          label="Confirm Email"
          type="email"
          fullWidth
          margin="normal"
          size="small"
          name="confirm_email"
          value={props.clinicData?.confirm_email}
          onChange={(e) => handleFieldChange(e, "confirm_email")}
          onPaste={handlePaste}
        />
        <TextField
          label="First Name"
          fullWidth
          margin="normal"
          size="small"
          name="first_name"
          value={props.clinicData?.first_name}
          onChange={(e) => handleFieldChange(e, "first_name")}
        />
        <TextField
          label="Last Name"
          fullWidth
          margin="normal"
          size="small"
          name="last_name"
          value={props.clinicData?.last_name}
          onChange={(e) => handleFieldChange(e, "last_name")}
        />
        <TextField
          label="Phone Number"
          fullWidth
          margin="normal"
          size="small"
          name="phone"
          value={props.clinicData?.phone}
          onChange={(e) => handleFieldChange(e, "phone")}
        />
        {role === "Super Admin" && (
          <FormControl fullWidth margin="normal" size="small">
            <InputLabel id="clinics-label">Clinics</InputLabel>
            <Select
              labelId="clinics-label"
              label="Clinics"
              name="clinics"
              value={props.clinicData?.clinics || ""}
              onChange={(e) => handleFieldChange(e, "clinics")}
            >
              {props.clinics.map((data) => (
                <MenuItem key={data.value} value={data.value}>
                  {data.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => props.AddClinicPatient()}
          disabled={!allFieldsFilled}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClinicAdmin;
